export default function setTitle(title="") {
  document.title = `${title} | Top250IMDBMov`
}
